var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAddFolder = function SvgAddFolder(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.869 12.93",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.38 12.93H1.489A1.51 1.51 0 0 1 0 11.427V1.5A1.51 1.51 0 0 1 1.489 0h5.517a.2.2 0 0 1 .16.074L8.535 1.7h6.845a1.51 1.51 0 0 1 1.489 1.5v8.227a1.51 1.51 0 0 1-1.489 1.503M5.611 6.715a.75.75 0 0 0 0 1.5h2.073v2.073a.75.75 0 0 0 1.5 0V8.215h2.073a.75.75 0 0 0 0-1.5H9.184V4.642a.75.75 0 0 0-1.5 0v2.073Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAddFolder);
export default ForwardRef;